import { type TableColumnsType } from 'antd';
import { numberSorter, stringSorter } from '../../../utils/antd-commons';

// Deal Manager: shared config for API paths and table columns
export type DealManagerView = "deal-grid" | "channel" | "territory" | "partner" | "platform" | "deals";




export const getDealManagerConfig = (view: DealManagerView): { apiPath: string; columns: TableColumnsType } => {
  if (view === "channel") {
    return {
      apiPath: "/register-data/channels",
      columns: [
        { title: "ID", dataIndex: "id", key: "id", sorter: (a: any, b: any) => numberSorter(a.id, b.id) },
        { title: "Name", dataIndex: "name", key: "name", sorter: (a: any, b: any) => stringSorter(a.name, b.name) },
        // activeColumn(),
      ],
    };
  }
  if (view === "territory") {
    return {
      apiPath: "/register-data/territories",
      columns: [
        { title: "ID", dataIndex: "id", key: "id", sorter: (a: any, b: any) => numberSorter(a.id, b.id) },
        { title: "Name", dataIndex: "name", key: "name", sorter: (a: any, b: any) => stringSorter(a.name, b.name) },
      ],
    };
  }
  if (view === "partner") {
    return {
      apiPath: "/register-data/partners",
      columns: [
        { title: "ID", dataIndex: "id", key: "id", sorter: (a: any, b: any) => numberSorter(a.id, b.id) },
        { title: "Name", dataIndex: "name", key: "name", sorter: (a: any, b: any) => stringSorter(a.name, b.name) },
      ],
    };
  }
  if (view === "platform") {
    return {
      apiPath: "/register-data/platforms",
      columns: [
        { title: "ID", dataIndex: "id", key: "id", sorter: (a: any, b: any) => numberSorter(a.id, b.id) },
        { title: "Name", dataIndex: "name", key: "name", sorter: (a: any, b: any) => stringSorter(a.name, b.name) },
      ],
    };
  }
  if (view === "deals") {
    return {
      apiPath: "/register-data/deals",
      columns: [
        { title: "ID", dataIndex: "id", key: "id", sorter: (a: any, b: any) => numberSorter(a.id, b.id) },
        { title: "Platform", dataIndex: "platform", key: "platform", sorter: (a: any, b: any) => stringSorter(a.platform, b.platform) },
        { title: "Partner", dataIndex: "partner", key: "partner", sorter: (a: any, b: any) => stringSorter(a.partner, b.partner) },
        { title: "Viewership Type", dataIndex: "viewership_type", key: "viewership_type", sorter: (a: any, b: any) => stringSorter(a.viewership_type, b.viewership_type) },
      ],
    };
  }
  // default: deal grid
  return {
    apiPath: "/register-data/deal-grid",
    columns: [
      { 
        title: "Deal Parent", 
        dataIndex: "deal_parent", 
        key: "deal_parent" ,
        sorter: (a: any, b: any) => numberSorter(a.deal_parent, b.deal_parent)
      },
      { title: "Platform", dataIndex: "platform", key: "platform", sorter: (a: any, b: any) => stringSorter(a.platform, b.platform) },
      { title: "Partner", dataIndex: "partner", key: "partner", sorter: (a: any, b: any) => stringSorter(a.partner, b.partner) },
      { title: "Channel", dataIndex: "channel", key: "channel", sorter: (a: any, b: any) => stringSorter(a.channel, b.channel) },
      { title: "Channel ID", dataIndex: "channel_id", key: "channel_id", sorter: (a: any, b: any) => numberSorter(a.channel_id, b.channel_id) },
      { title: "Territory", dataIndex: "territory", key: "territory", sorter: (a: any, b: any) => stringSorter(a.territory, b.territory) },
      { title: "Territory ID", dataIndex: "territory_id", key: "territory_id", sorter: (a: any, b: any) => numberSorter(a.territory_id, b.territory_id) },
    ],
  };
};